// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"285":"821d1774","336":"8eafa97f","725":"c8ff2a1f","898":"d32dbda1"}[chunkId] + ".chunk.css";
};